import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { useForgotPassword } from '../hooks/useAuthApi';
import { toast } from 'react-toastify';

export default function ForgotPasswordPage() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const { register, handleSubmit, formState: { errors } } = useForm();
  const { mutate: sendResetLink, isPending } = useForgotPassword();

  const onSubmit = (data) => {
    sendResetLink(data.email, {
      onSuccess: (response) => {
        toast.success(response.message);
        setIsSubmitted(true);
      },
      onError: (error) => {
        toast.error(error.response?.data?.message || 'An error occurred.');
      },
    });
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="w-full max-w-md p-8 space-y-6 bg-white rounded-lg shadow-md">
        {isSubmitted ? (
          <div className="text-center">
            <h2 className="text-2xl font-bold">Check Your Inbox</h2>
            <p className="mt-4 text-gray-600">If an account with that email exists, a password reset link has been sent. Please check your email to proceed.</p>
            <Link to="/login" className="inline-block mt-6 px-4 py-2 text-sm font-medium text-white bg-[#2C4E86] rounded hover:bg-blue-900">
              Back to Login
            </Link>
          </div>
        ) : (
          <>
            <h2 className="text-2xl font-bold text-center">Forgot Your Password?</h2>
            <p className="text-center text-gray-600">No worries! Enter your email below and we'll send you a reset link.</p>
            <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email Address</label>
                <input
                  id="email"
                  type="email"
                  {...register('email', { required: 'Email is required' })}
                  className="w-full p-2 mt-1 border rounded"
                />
                {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email.message}</p>}
              </div>
              <button
                type="submit"
                disabled={isPending}
                className="w-full px-4 py-2 font-medium text-white bg-[#2C4E86] rounded hover:bg-blue-900 disabled:bg-blue-300"
              >
                {isPending ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}